<template>
  <div class="home-contract-list">
    <action-bar>
      <search placeholder="请输入合约名称" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <normal-table
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :show-edit="true"
        :paging="paging"
        @handleSelectionChange="handleSelectionChange"
        @pagination="getList"
      >
      </normal-table>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'List',
  components: {
    subscribeBlock
  },
  data() {
    return {
      // 设置table的列
      tableCol: [
        {
          prop: 'name',
          label: '目标合约',
          minWidth: 214
        },
        {
          prop: 'version',
          label: '当前版本号',
          icon: 'icon-version',
          formatter: row => {
            return `v${row.version}`
          },
          minWidth: 115
        },
        {
          prop: 'runtimeType',
          label: '合约类型',
          formatter: row => {
            return this.runtimeTypeArr[row.runtimeType]
          },
          minWidth: 116
        },
        {
          prop: 'TxNum',
          label: '累计交易数',
          minWidth: 116
        },
        {
          prop: 'CreateBy',
          label: '创建用户',
          minWidth: 116
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 158
        },
        {
          prop: 'UpdateBy',
          label: '最新更新用户',
          minWidth: 132
        },
        {
          prop: 'updateAt',
          label: '最新更新时间',
          minWidth: 158,
          formatter: row => {
            return this.formatTime(row)
          }
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          showText: true,
          class: 'operate-check',
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check'
        }
      ],
      operatorCol: {
        minWidth: 74
      },
      //"INVALID": 0, "NATIVE": 1, "WASMER": 2, "WXVM": 3, "GASM": 4, "EVM": 5, "DOCKER_GO": 6, "DOCKER_JAVA": 7,
      runtimeTypeArr: [
        'INVALID',
        'NATIVE',
        'WASMER',
        'WXVM',
        'GASM',
        'EVM',
        'DOCKER_GO',
        'DOCKER_JAVA'
      ]
    }
  },
  computed: {
    ...mapState({
      list: state => state.home.contract_list,
      paging: state => state.home.contract_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getList()
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getContractLists']),

    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    },
    onSearch(val) {
      this.getList({
        offset: 0,
        limit: 10,
        contractName: val
      })
    },

    getList(params) {
      let sendObj = {
        offset: params?.offset * params?.limit || 0,
        limit: params?.limit || 10,
        chainId: this.$store.state.home.chainCid,
        contractName: params?.contractName || ''
      }
      this.getContractLists(sendObj)
    },

    getInfo(row) {
      this.$router.push({
        name: 'contractDetail',
        query: { contractName: row.name }
      })
    },
    handleSelectionChange() {
      this.getList({
        offset: 0,
        limit: 10,
        chainId: this.$store.state.home.chainCid
      })
    },

    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-contract-list',
  (
    --home-contract-list-operate-check-color: #45c2ff
  ),
  (
    --home-contract-list-operate-check-color: #45c2ff
  )
);
.home-contract-list {
  @include adaptation(
    (
      --home-contract-list-search-width: 253px,
      --home-contract-list-offset: 48px
    )
  );
  --home-contract-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-contract-list-offset)
  );

  .cbaas-search-wrap {
    width: var(--home-contract-list-search-width);
  }

  .common-bg-plate {
    .normal-table-wrap {
      height: 100%;
      min-height: var(--home-contract-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-contract-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--home-contract-list-min-height);

          .operate-item.operate-check {
            color: var(--home-contract-list-operate-check-color);
          }
        }
      }
    }
  }
}
</style>
